import {Circle, Group, Line, Text} from "react-konva";
import type {GridPoint} from "@/dungeons/model/DungeonGeometry.ts";

/** A screen-sized, non-interactive marker in either image or world coordinates. */
export default function TransitionArrivalMarker({point, origin, zoom, label = "Ankunft"}: {
    point: GridPoint;
    origin?: GridPoint;
    zoom: number;
    label?: string;
}) {
    const scale = Math.max(zoom, Number.EPSILON);
    const distance = origin ? Math.hypot(point.x - origin.x, point.y - origin.y) * scale : 0;
    return <Group listening={false}>
        {origin && distance > 16 && <Line points={[origin.x, origin.y, point.x, point.y]}
            stroke="#fbbf24" opacity={0.8} strokeWidth={1.5 / scale}
            dash={[6 / scale, 5 / scale]} listening={false}/>}
        <Circle x={point.x} y={point.y} radius={11 / scale} fill="rgba(0,0,0,0.75)"
            stroke="#fbbf24" strokeWidth={2 / scale} listening={false}/>
        <Circle x={point.x} y={point.y} radius={3 / scale} fill="#fbbf24" listening={false}/>
        <Text text={label} x={point.x + 16 / scale} y={point.y - 8 / scale}
            fontSize={12 / scale} fontStyle="bold" fill="#fef3c7"
            shadowColor="black" shadowBlur={4 / scale} listening={false}/>
    </Group>;
}
